import { useMemo } from "react";
import { useClientQuery } from "web_myplann/Api/Client/useClientQuery";
import type { InspirationBaseline } from "web_myplann/Inspiration/Types/InspirationBaseline";
import { useFinancialBalance } from "web_myplann/Shared/Hooks/useFinancialBalance";
import { getAgeFromDate } from "web_myplann/Shared/Utils/getAgeFromDate";
import { parseDate } from "web_myplann/Shared/Utils/parseDate";

export const useInspirationBaseline = (): InspirationBaseline => {
	const { data: client, isPending: isClientPending } = useClientQuery();
	const {
		incomeSum,
		expenseSum,
		balance,
		hasExpenses,
		isPending: isBalancePending,
	} = useFinancialBalance();

	const bornDate = client?.data?.bornDate;
	const age = getAgeFromDate(bornDate);
	const birthDate = useMemo(
		() => (age === undefined ? undefined : parseDate(bornDate)),
		[age, bornDate],
	);

	return {
		age,
		birthDate,
		income: incomeSum,
		monthlyExpenses: hasExpenses ? expenseSum : undefined,
		freeCashflow: Math.max(0, balance),
		isLoaded: !isClientPending && !isBalancePending,
	};
};
